import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ZoneRendererService } from 'abs-ngx-library/src/lib/core';

@Component({
  selector: 'zone',
  templateUrl: './zone.component.html',
})


export class ZoneComponent implements AfterViewInit {
  @Input() componentType: string = '';
  @Input() componentData: any = null;
  @Input() zoneId: string = "";

  @ViewChild('zone', { static: false }) zoneRef: ElementRef;
 
  constructor(private _zoneRendererService: ZoneRendererService) { }   

  ngAfterViewInit(): void {
    if (!this.zoneRef?.nativeElement) return;
    if (!this.componentData) return;
    
    if (this.componentType === 'gridRow' || this.componentType === 'gridRowWithFacets') {
      const transformedData = {items: [this.componentData]};
      const isGridWithFacets = this.componentType === 'gridRowWithFacets';
      this._zoneRendererService.renderGridZone(this.zoneRef.nativeElement, transformedData, isGridWithFacets);
      return;
    }
    // this._zoneRendererService.renderGridZone(this.zoneRef.nativeElement, this.componentData);
    // TODO: Create regular flow for rendering zone when required.
  }

}
